import { render, staticRenderFns } from "./VTitle.vue?vue&type=template&id=a11dbec8&scoped=true&"
import script from "./VTitle.vue?vue&type=script&lang=js&"
export * from "./VTitle.vue?vue&type=script&lang=js&"
import style0 from "./VTitle.vue?vue&type=style&index=0&id=a11dbec8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11dbec8",
  null
  
)

export default component.exports